import React, { useState, useEffect, useCallback } from "react"
import CarouselContents from "./CarouselContents"
import CarouselSlide from "./CarouselSlide"
import { useSelector, useDispatch } from "react-redux"
import { updateSortOptions } from '../store/actions/restaurantActions'
import {setImage} from '../components/layout/SetImage'

function HorizontalSlider({ contents }) {
  // The value of the item that is supposed to be the center
  const selectSortOptions = useSelector((state)=>state.restaurant.sortOptions);
  const [centerVal, setCenterVal] = useState(selectSortOptions.carouselPosition);
  const dispatch = useDispatch();
  useEffect(()=>{if(selectSortOptions.carouselPosition !== centerVal){
    selectSortOptions.carouselPosition = centerVal;
    dispatch(updateSortOptions(selectSortOptions));}
  },[centerVal])


  // const callbackSortOptions = useCallback((sortOptions) => dispatch(updateSortOptions(sortOptions)), []);
  // useEffect( () => () => {console.log("unmount");
  //                         selectSortOptions.carouselPosition = centerVal;
  //                         callbackSortOptions(selectSortOptions);       
  //                         }, [] );
  
  
  // Length of contents must be >= 5 as window size is 5
  return (
    contents.map((q, index) => {
      return(
            <div key={q.label} style={{padding:"5px"}} onClick={function(){selectSortOptions.sortTags = [{"value":q.label,"label":q.label}];
                selectSortOptions.sortName = [];
                selectSortOptions.sortCombined = [{"value":q.label,"label":q.label}];
                selectSortOptions.carouselPosition = centerVal;
                selectSortOptions.summaryChange = true;
                dispatch(updateSortOptions(selectSortOptions));
              }}>
              {setImage(q.label)}
            </div>
      )
    })
  );
}

export default HorizontalSlider;